module.exports = __webpack_public_path__ + "static/media/soils_example_1_1.29cb8c63.png";


//////////////////
// WEBPACK FOOTER
// ./public/stem_soils_images/soils_example_1_1.png
// module id = 1279
// module chunks = 0